import { observer } from "mobx-react";
import UserView from "pages/UserView/UserView";
import React, { useEffect } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { useStore } from "store/StoreConfigs";

function UsersManagementModule() {
    const { commonStore, filtersStore } = useStore();
    const history = useHistory();

    useEffect(() => {
        commonStore.setSelectedTab(5);
        filtersStore.setModule("Users");
    }, []);
    return (
        <Switch>
            <Route exact path="/users">
                <UserView />
            </Route>
            <Route path="*">{() => history.push("/thor")}</Route>
        </Switch>
    );
}
export default observer(UsersManagementModule);
